import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import AdminShell from "../components/AdminShell";
import AppPage from "../components/AppPage";
import { adminCompaniesApi } from "../api";

const fmtDate = (iso) => {
  if (!iso) return "—";
  try {
    return new Date(iso).toLocaleDateString("ru-RU");
  } catch {
    return iso;
  }
};

export default function AdminCompanies() {
  const { t } = useTranslation();
  const [q, setQ] = useState("");
  const [search, setSearch] = useState("");
  const [rows, setRows] = useState([]);
  const [total, setTotal] = useState(0);
  const [err, setErr] = useState("");

  const load = async () => {
    setErr("");
    try {
      const data = await adminCompaniesApi({ q: search, limit: 100 });
      setRows(data.items || []);
      setTotal(data.total || 0);
    } catch (e) {
      setErr(e?.response?.data?.detail || t("admin.load_error"));
    }
  };

  useEffect(() => { load(); /* eslint-disable-next-line */ }, [search]);

  return (
    <AdminShell title={t("admin.nav.companies")}>
      <AppPage
        bodyScroll="table"
        toolbar={(
          <>
      <form
        className="row g-2 mb-3"
        onSubmit={(e) => { e.preventDefault(); setSearch(q.trim()); }}
      >
        <div className="col-md-6">
          <input
            className="form-control"
            placeholder={t("admin.search_company")}
            value={q}
            onChange={(e) => setQ(e.target.value)}
          />
        </div>
        <div className="col-auto">
          <button type="submit" className="btn btn-primary">{t("common.search")}</button>
        </div>
        <div className="col-auto ms-md-auto align-self-center small text-muted">
          {total} {t("admin.companies_total")}
        </div>
      </form>

      {err && <div className="alert alert-danger">{err}</div>}
          </>
        )}
      >
      <table className="table table-hover mb-0 align-middle card border-0 shadow-sm">
            <thead className="table-light">
              <tr>
                <th>{t("common.company")}</th>
                <th>{t("admin.col.director")}</th>
                <th>{t("admin.col.employees")}</th>
                <th>{t("admin.col.created")}</th>
                <th>БИН</th>
                <th>{t("admin.col.source")}</th>
              </tr>
            </thead>
            <tbody>
              {rows.length === 0 ? (
                <tr>
                  <td colSpan={6} className="text-center text-muted py-4">{t("admin.no_data")}</td>
                </tr>
              ) : rows.map((co) => (
                <tr key={co.company_id}>
                  <td>
                    <div className="fw-semibold">{co.name}</div>
                    <div className="small text-muted font-monospace">{co.company_id}</div>
                  </td>
                  <td className="small">
                    <div>{co.director_name || "—"}</div>
                    <div className="text-muted">{co.director_email || "—"}</div>
                  </td>
                  <td>{co.employees_count ?? 0}</td>
                  <td className="text-nowrap small">{fmtDate(co.created_at)}</td>
                  <td className="small">{co.bin || "—"}</td>
                  <td className="small">
                    {co.registered_via === "ecp" ? (
                      <span className="badge bg-primary">ЭЦП</span>
                    ) : (
                      <span className="badge bg-secondary">Web</span>
                    )}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
      </AppPage>
    </AdminShell>
  );
}
